import { render, staticRenderFns } from "./InvestmentsSettingsForm.vue?vue&type=template&id=5d40a60f&"
import script from "./InvestmentsSettingsForm.vue?vue&type=script&lang=js&"
export * from "./InvestmentsSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports